import React from 'react';
import { divider } from './styles';
import settings from '@settings';

const Divider = ({showLine= false, sizes= 'medium'}: {showLine?: boolean, sizes?: 'small' | 'medium' | 'large'}) => {
	return (
		<div css={[
			divider,
			{
				backgroundColor: showLine ? settings.colors.dark : 'transparent',
				marginTop: settings.sizes[sizes],
				marginBottom: settings.sizes[sizes]
			}

		]} />
	);
};

export default Divider;